import { render, staticRenderFns } from "./CardDataComponent.vue?vue&type=template&id=88b08b34&scoped=true&"
import script from "./CardDataComponent.vue?vue&type=script&lang=js&"
export * from "./CardDataComponent.vue?vue&type=script&lang=js&"
import style0 from "./CardDataComponent.vue?vue&type=style&index=0&id=88b08b34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b08b34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88b08b34')) {
      api.createRecord('88b08b34', component.options)
    } else {
      api.reload('88b08b34', component.options)
    }
    module.hot.accept("./CardDataComponent.vue?vue&type=template&id=88b08b34&scoped=true&", function () {
      api.rerender('88b08b34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/card-data/CardDataComponent.vue"
export default component.exports